import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Use basename in production, but not in development for easier testing
const basename = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
  ? ""
  : "/sandyrandhawa";

root.render(
  <BrowserRouter basename={basename}>
    <App />
  </BrowserRouter>
);
